import {useCurrentHost, useLocalePrefix, useRequestURL} from '#imports';

export function useDomainChecker() {
    const currentHost = useCurrentHost();
    const {hasLocalePrefix} = useLocalePrefix();

    function isMaltDotCom(): boolean {
        return currentHost.getCurrentHost().endsWith('malt.com') && !currentHost.getCurrentHost().startsWith('ae.');
    }

    function isMaltDotComWithoutPrefix(): boolean {
        const host = currentHost.getCurrentHost();
        return host.endsWith('malt.com') && !host.startsWith('ae.') && !hasLocalePrefix(useRequestURL().pathname);
    }

    return {
        isMaltDotCom,
        isMaltDotComWithoutPrefix,
    };
}
